export enum FeatureStatus {
  ComingSoon = 'ComingSoon',
  Preview = 'Preview',
  New = 'New',
  Stable = 'Stable',
}
